







































import {Emit, Prop} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Approvisionnement, Fournisseur} from '@/models';

import CrudApprovisionnementEdit from '@/components/Crud/Approvisionnement/Edit.vue';

@Component({
	components: {
		CrudApprovisionnementEdit,
	}
})
export default class CrudApprovisionnementEditDialog extends Vue {
	@InOut({ type: Approvisionnement  , isVModel: true }) private value!: Approvisionnement;
	@Prop({ type: Fournisseur, default: null}) fournisseur: Fournisseur;

	@Emit()
	private onSubmit(approvisionnement: Approvisionnement) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
